import { TYPES } from '../../common/constants';

export const setPropertyFormData = payload => ({
  type: TYPES.SET_PROPERTY_FORM_DATA,
  payload,
});


export const clearPropertyFormData = () => ({
  type:TYPES.CLEAR_PROPERTY_FORM_DATA,
 })